var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[
    { spin: _vm.spin },
    { disabled: _vm.disabled },
    _vm.sizeClass,
    { 'color-reset': _vm.colorReset } ],domProps:{"innerHTML":_vm._s(_vm.getSvg())},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }